import React from "react";
import { Table } from "react-bootstrap";
// import useReactRouter from "use-react-router";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import {
//   faBoxesStacked,
//   faFileExcel,
//   faPlus,
//   faDollarSign,
//   faPrint,
// } from "@fortawesome/free-solid-svg-icons";
// import { ChromePicker } from "react-color";
// import * as _ from "lodash";

import moment from "moment";
import {
  convertOrderStatus,
  convertOrderType,
  getOrderSourceLabel,
} from "../../helpers/orderStatus";
// import { convertPaymentStatus } from "../../helpers/paymentStatus";
// import EmptyComponent from "../../components/EmptyComponent";
import "react-spring-bottom-sheet/dist/style.css";
import PaginationHelper from "../../helpers/PaginationHelper";
import { BRAND_RED, BRAND_PURPLE, COLOR_WHITE, VANESSA_SHOP_ID } from "../../constants";

//* ໄຟລ໌ Excel ອ່ານສະເພາະ style ທີ່ຂຽນຕິດ cell: gradient ຂອງແອັບ (COLOR_APP) ໃຊ້ບໍ່ໄດ້ → ໃຊ້ສີແບຣນດຽວ
//* ຟອນຈະສະແດງຄືແອັບ ຖ້າເຄື່ອງມີ Noto Sans Lao
const EXCEL_FONT = '"Noto Sans Lao", sans-serif';
const CELL_STYLE = { fontFamily: EXCEL_FONT };
const HEADER_STYLE = {
  fontFamily: EXCEL_FONT,
  fontWeight: "bold",
  backgroundColor: BRAND_RED,
  color: COLOR_WHITE,
  textAlign: "left",
  whiteSpace: "nowrap",
};
const EXCEL_HEADERS = [
  "#",
  "ເລກທີໃບສັ່ງຊື້",
  "ຫົວຂໍ້",
  "ຊື່ລູກຄ້າ",
  "ປະເພດ",
  "ອໍເດີ້ມາຈາກ",
  "ລະຫັດ CF",
  "ຊື່ສິນຄ້າ",
  "ຈຳນວນ",
  "ລວມເງິນເກີບທັງໝົດ",
  "ລວມເງິນບາດທັງໝົດ",
  "ລວມເງິນໂດລາທັງໝົດ",
  "ວັນທີ",
  "ປະເພດຈ່າຍ",
  "ການຊຳລະ",
  "ສະຖານະ",
];

function OrderGroupDownload({ orderGroupDownload }) {
  //* ຖັນບິນ OT — ສະເພາະຮ້ານ Vanessa
  const showOT = VANESSA_SHOP_ID.includes(localStorage.getItem("SHOP"));
  const headers = showOT ? [...EXCEL_HEADERS, "ບິນ OT"] : EXCEL_HEADERS;
  const getCfMessage = (orders) => {
    return orders?.map(({ cfMessage }) => cfMessage).join(", ");
  };
  const getProductName = (orders) => {
    return orders?.map(({ productName }) => productName).join(", ");
  };
  const getProductAmount = (orders) => {
    return orders?.reduce((total, { amount }) => total + amount, 0);
  };

  // Paggination helper
  const { _limit, _skip, Pagination_helper } = PaginationHelper();
  return (
    <Table
      id="table-to-xls"
      style={{
        marginTop: "20px",
        borderCollapse: "collapse",
        width: "100% ",
        display: "none",
      }}>
      <tbody>
        <tr style={{ height: "40px", verticalAlign: "middle" }}>
          {headers.map((title) => (
            <th key={title} bgcolor={BRAND_RED} style={HEADER_STYLE}>
              {/* Excel ອ່ານສີຕົວອັກສອນຈາກ <font> ໄດ້ແນ່ນອນກວ່າ style */}
              <font color={COLOR_WHITE}>{title}</font>
            </th>
          ))}
        </tr>
      </tbody>
      <tbody>
        {orderGroupDownload?.map((order, index) => (
          <tr style={{ verticalAlign: "middle", height: "59px" }} key={index}>
            <td style={CELL_STYLE}>{index + 1 + _limit * (_skip - 1)}</td>
            <td style={CELL_STYLE}>
              <div
                to={"/order-detailorder"}
                style={{
                  color: BRAND_PURPLE,

                  textDecoration: "underline",
                }}>
                {order?.code ?? "-"}
              </div>
            </td>
            <td style={CELL_STYLE}>{order?.live?.description}</td>
            <td style={CELL_STYLE}>
              {order?.customerName !== "" && order?.customerName
                ? order?.customerName
                : order?.cfName}
            </td>
            <td style={CELL_STYLE}>{convertOrderType(order?.type)}</td>
            <td style={CELL_STYLE}>{getOrderSourceLabel(order)}</td>
            <td style={CELL_STYLE}>{getCfMessage(order?.orders)}</td>
            <td style={CELL_STYLE}>{getProductName(order?.orders)}</td>
            <td style={CELL_STYLE}>{getProductAmount(order?.orders)}</td>
            <td style={CELL_STYLE}>
              {" "}
              <p
                style={{ fontWeight: "bold" }}

              //   onClick={selectedIds.length > 0 ? () => setShowUpdateStatus(true) : () => onUpdateOneOrder(index)}
              >
                {new Intl.NumberFormat("en-US").format(order?.totalPrice)}
              </p>
            </td>
            <td style={CELL_STYLE}>
              {" "}
              <p
                style={{ fontWeight: "bold" }}

              //   onClick={selectedIds.length > 0 ? () => setShowUpdateStatus(true) : () => onUpdateOneOrder(index)}
              >
                {new Intl.NumberFormat("en-US").format(order?.sumPriceBaht)}
              </p>
            </td>
            <td style={CELL_STYLE}>
              {" "}
              <p
                style={{ fontWeight: "bold" }}

              //   onClick={selectedIds.length > 0 ? () => setShowUpdateStatus(true) : () => onUpdateOneOrder(index)}
              >
                {new Intl.NumberFormat("en-US").format(order?.sumPriceUsd)}
              </p>
            </td>
            <td style={CELL_STYLE}>{moment(order?.createdAt).format("DD/MM/YYYY HH:mm")}</td>
            <td style={CELL_STYLE}>
              {order?.isPaymented === true ? "ຈ່າຍສົດ" : "ໂອນ"}
              {/* {order.payment === "cash" ? "ຈ່າຍສົດ" : ""}
                    {order.payment === "transfer" ? "ໂອນ" : ""} */}
            </td>
            <td style={{ ...CELL_STYLE, color: order?.isPaymented ? 'green' : 'red' }}>{order?.isPaymented ? 'ຊໍາລະແລ້ວ' : 'ຍັງບໍ່ຊໍາລະ'}</td>
            <td style={CELL_STYLE}>
                {convertOrderStatus(order?.status)}
            </td>
            {showOT && <td style={CELL_STYLE}>{order?.isOT ? "OT" : "-"}</td>}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
export default OrderGroupDownload;
